export default function SectionHeader({ overline, title, lede, align = "left", testId }) {
  return (
    <div
      data-testid={testId}
      className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
    >
      {overline && <div className="ra-overline">{overline}</div>}
      <h2 className="ra-serif text-4xl sm:text-5xl lg:text-6xl mt-4 leading-[1.02]">{title}</h2>
      {lede && (
        <p className="mt-5 text-base sm:text-lg text-ra-soft leading-relaxed max-w-2xl">
          {lede}
        </p>
      )}
    </div>
  );
}
